import { render, staticRenderFns } from "./GestionFormularios.vue?vue&type=template&id=2fa05222"
import script from "./GestionFormularios.vue?vue&type=script&lang=js"
export * from "./GestionFormularios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports